"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLogin = void 0;
const api_1 = require("core/api");
const React = __importStar(require("react"));
const useRequest_1 = require("src/hooks/useRequest");
const authFormDefault = {
    email: '',
    password: '',
};
const useLogin = () => {
    const [authForm, setAuthForm] = React.useState(authFormDefault);
    const [formErrors, setFormErrors] = React.useState({});
    const { data, isProcessing, error, makeRequest } = (0, useRequest_1.useRequest)();
    const onSubmit = async () => {
        // validate fields
        const validationErrors = {};
        if (!authForm.email) {
            validationErrors['email'] = 'Email is required';
        }
        if (!authForm.password) {
            validationErrors['password'] = 'Password is required';
        }
        if (Object.keys(validationErrors).length > 0) {
            setFormErrors(validationErrors);
            return;
        }
        await makeRequest(() => api_1.AuthenticationService.authenticateUser({
            username: authForm.email,
            password: authForm.password,
        }), 'Login Successful');
    };
    return {
        authForm,
        onSubmit,
        authError: !!error,
        setAuthForm: (key, value) => {
            setAuthForm({ ...authForm, [key]: value });
        },
        isProcessing,
        authenticated: data?.success,
        formErrors,
    };
};
exports.useLogin = useLogin;
